import { format } from 'owa-strings';
import { userDate } from 'owa-datetime/lib/owaDate/owaDate';
import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import formatUserTime from 'owa-datetime/lib/formatters/formatUserTime';
import isSameDay from 'owa-datetime/lib/owaDate/isSameDay';
import strings from 'owa-strings/owa-common-strings';
import {
    FIVE_MINUTES_IN_MILLISECONDS,
    TWENTY_MINUTES_IN_MILLISECONDS,
    MINUTE_IN_MILLISECONDS,
} from '../utils/UpNextConstants';

export default function getTimeToNextMeeting(nextMeeting: CalendarItem): string {
    let timeToNextMeeting: string;

    const now = userDate();
    const meetingStart = userDate(nextMeeting.Start);
    const isTodayMeeting = isSameDay(now, meetingStart);
    const millisecondsDifference = now.getTime() - meetingStart.getTime();

    if (millisecondsDifference >= 0 && millisecondsDifference <= FIVE_MINUTES_IN_MILLISECONDS) {
        timeToNextMeeting = strings.now;
    } else if (
        millisecondsDifference < 0 &&
        Math.abs(millisecondsDifference) <= TWENTY_MINUTES_IN_MILLISECONDS
    ) {
        const minutes = Math.ceil(Math.abs(millisecondsDifference) / MINUTE_IN_MILLISECONDS);
        timeToNextMeeting =
            minutes <= 1 ? strings.inOneMinute : format(strings.inXMinutes, minutes);
    } else {
        // Regular time.
        timeToNextMeeting = format(
            isTodayMeeting ? strings.todayAt : strings.tomorrowAt,
            formatUserTime(meetingStart)
        );
    }

    return timeToNextMeeting;
}
